<template>
  <div v-if="editedItem"
       v-loading="loadingInfo">
    <div class="ca_wrapper" >
      <v-card>
      <v-layout row wrap>
        <v-flex xs5>
          <v-card-title class="headline">CA進件</v-card-title>
        </v-flex>
      </v-layout>
      <v-card-text>
        <v-layout row wrap>
          <v-layout row wrap>
            <v-flex xs3>申請日期：</v-flex>
            <v-flex xs3>
              <v-select
                v-model="editedItem.applyDate.year"
                :items="yearList"
                item-text="name"
                item-value="key"
                label="年"
              ></v-select>
            </v-flex>
            <v-flex xs3>
              <v-select
                v-model="editedItem.applyDate.month"
                :items="monthList"
                item-text="name"
                item-value="key"
                label="月"
              ></v-select>
            </v-flex>
            <v-flex xs3>
              <v-select
                v-model="editedItem.applyDate.day"
                :items="dayList"
                item-text="name"
                item-value="key"
                label="日"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-layout row wrap>
            <!-- <v-flex xs6>
              <v-select :items="caseTypeList"
                        item-text="text"
                        item-value="key"

                        label="業務別"
                        outline
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select :items="promotionList"
                        item-text="text"
                        item-value="key"
                        label="專案"
                        outline
              ></v-select>
            </v-flex> -->
          </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
            <!-- <v-flex xs6>
              <v-select :items="productCategoryList"
                        item-text="text"
                        item-value="key"
                        v-model="officialItem.productCategoryId"
                        label="商品品牌"
                        outline
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select :items="productIdList"
                        item-text="text"
                        item-value="key"
                        v-model="officialItem.productId"
                        label="商品名稱"
                        outline
              ></v-select>
            </v-flex> -->
          </v-layout>
        <v-divider></v-divider>

          <v-layout row wrap>
            <h2>基本資料</h2>
          </v-layout>
          <v-layout row wrap>
            <v-flex pt-4 xs2>
              <v-text-field
              v-model="editedItem.customer.name"
              :label="`中文姓名`"
              background-color='#49bcfd'
              placeholder="1.必填" outline></v-text-field>
            </v-flex>
            <v-flex pt-4 xs2>
              <v-text-field
                v-model="editedItem.customer.memberId"
                :label="`身分證字號`"
                placeholder="2.必填"
                background-color='#49bcfd'
                outline
              ></v-text-field>
            </v-flex>
            <v-flex ml-2 xs5>
              <span>出生日期</span>
              <date-time-tool
              :date-info="editedItem.customer.birthdayInfo"
              :background-color="`#49bcfd`"
              @handleDateChange="customerDateChange"></date-time-tool>
            </v-flex>
            <v-flex xs6>
            </v-flex>
          </v-layout>
          <!-- <v-layout row wrap>
            <v-flex xs6>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-checkbox v-model="editedItem.customer.memberIdType[0].value" label="初發"></v-checkbox>
                </v-flex>
                <v-flex xs4>
                  <v-checkbox v-model="editedItem.customer.memberIdType[1].value" label="補發"></v-checkbox>
                </v-flex>
                <v-flex xs4>
                  <v-checkbox v-model="editedItem.customer.memberIdType[2].value" label="換發"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.customer.memberIdDate"
                    label="身分證初補換"
                    placeholder="4.必填"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="editedItem.customer.memberIdDate"
                label="發證地點"
                placeholder="5.必填"
              ></v-text-field>
            </v-flex>
          </v-layout> -->
          <v-layout>
            <v-flex xs6>
              <v-layout row wrap>
                <v-flex xs10>
                  <v-text-field
                    v-model="editedItem.customer.cellphone"
                    :disabled="editedItem.customer.hasCellphone"
                    label="行動電話"
                    placeholder="必填"
                    background-color='#49bcfd'
                    outline
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="shrink ma-4">
            <h2>職業資料</h2>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap>
                <div>公司名稱</div>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs8>
                  <v-layout row wrap>
                      <v-text-field
                        v-model="editedItem.company.name"
                        placeholder="12.必填"
                      ></v-text-field>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <v-layout row wrap>
                <v-flex xs8>
                  <v-text-field
                    v-model="editedItem.company.phone"
                    :disabled="editedItem.company.hasPhone"
                    label="公司電話"
                    placeholder="13.必填"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <h2>經銷商填寫欄</h2>
          </v-layout>
          <v-layout>
            <h3>分期內容</h3>
          </v-layout>
          <v-layout>
<!--            <v-flex xs3>-->
<!--              <v-select v-model="editedItem.vendor.productId"-->
<!--                item-text="value"-->
<!--                item-value="key"-->
<!--               :items="getCaseTypeList" label="商品名稱"></v-select>-->
<!--            </v-flex>-->
<!--            <v-flex xs3>-->
<!--              <v-text-field label="頭款(訂金)"></v-text-field>-->
<!--            </v-flex>-->
            <v-flex xs3>
              <v-text-field
                v-model="editedItem.vendor.totalPrice"
                v-if="canCustomPrice"
                label="商品總價"
              ></v-text-field>
              <v-select
                v-else
                v-model="editedItem.vendor.totalPrice"
                @change="changeInstallmentsNumber"
                :items="getCreditPriceList"
                label="商品總價"
              ></v-select>
            </v-flex>
<!--            <v-flex xs3>-->
<!--              <v-text-field label="辦理分期金額(商品總價-已付頭款)"></v-text-field>-->
<!--            </v-flex>-->
          </v-layout>
          <v-layout>
            <v-flex xs4>
              <v-text-field
                v-model="editedItem.vendor.installmentsNumber"
                v-if="canCustomPrice"
                label="期數"
              ></v-text-field>
              <v-select
                v-else
                v-model="editedItem.vendor.installmentsNumber"
                @change="changeInstallmentsNumber"
                :items="getInstallmentsNumberList"
                label="期數"
              ></v-select>
            </v-flex>
            <v-flex xs4>
              <v-text-field v-model="editedItem.vendor.creditPriceMonth" label="每期應繳金額(期付款)"></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="editedItem.vendor.totalCreditPrice"
                v-if="canCustomPrice"
                label="分期總額(期數X期付金額)"
              ></v-text-field>
              <span v-else>{{editedItem.vendor.totalCreditPrice}}</span>
            </v-flex>
          </v-layout>

      <use-case-view
        :item-detail="editedItem"
        @changeEvent="changeEvent"
        @uploadEvent="uploadEvent"
      ></use-case-view>

      </v-card-text>
    </v-card>



      <div class="btn"><a href="" @click.prevent="save">確認上傳</a></div>

      <v-dialog
      v-model="dateInfoDialog.visible"
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-title class="headline">
          {{dateInfoDialog.text}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap v-if="dateInfoDialog.key === 'birthday'">
            <v-flex sm3>
                <v-text-field outlined v-model="editedItem.customer.birthdayInfo.year" length="3" maxlength="3"
                          placeholder="年(民國)"></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field outlined v-model="editedItem.customer.birthdayInfo.month" length="2" maxlength="2"
                          placeholder="月(ex. 01)"></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field outlined v-model="editedItem.customer.birthdayInfo.day" length="2" maxlength="2"
                          placeholder="日(ex. 01)"></v-text-field>
            </v-flex>
          </v-layout>

          <div v-if="dateInfoDialog.key === 'memberIdDate'">
            <v-layout row wrap>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.customer.memberIdDateInfo.year" length="3" maxlength="3"
                          placeholder="年(民國)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.customer.memberIdDateInfo.month" length="2" maxlength="2"
                          placeholder="月(ex. 01)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.customer.memberIdDateInfo.day" length="2" maxlength="2"
                          placeholder="日(ex. 01)"></v-text-field>
              </v-flex>
            </v-layout>
          </div>
          <div v-if="dateInfoDialog.key === 'jointGuarantor.birthday'">
            <v-layout row wrap>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.birthdayInfo.year" length="3" maxlength="3"
                          placeholder="年(民國)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.birthdayInfo.month" length="2" maxlength="2"
                          placeholder="月(ex. 01)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.birthdayInfo.day" length="2" maxlength="2"
                          placeholder="日(ex. 01)"></v-text-field>
              </v-flex>
            </v-layout>
          </div>
          <div v-if="dateInfoDialog.key === 'jointGuarantor.memberIdDate'">
            <v-layout row wrap>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.memberIdDateInfo.year" length="3" maxlength="3"
                          placeholder="年(民國)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.memberIdDateInfo.month" length="2" maxlength="2"
                          placeholder="月(ex. 01)"></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-text-field outlined v-model="editedItem.jointGuarantor.memberIdDateInfo.day" length="2" maxlength="2"
                          placeholder="日(ex. 01)"></v-text-field>
              </v-flex>
            </v-layout>
          </div>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" dark text :loading="loadingInfo" @click="dateInfoDialog.confirm">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-dialog
        fullscreen hide-overlay
        v-model="signDialog.visible">
        <v-card>
          <v-card-text>
            <draw-canvas :visible="signDialog.visible" @handleDownloadSign="handleDownloadSign"  @closeEvent="handleDownloadClose"></draw-canvas>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!--提示-->
      <alert-view :visible="messageDialog.visible"
                  :title="messageDialog.title"
                  :content="messageDialog.text"
                  @confirmEvent="messageDialog.confirm">
                </alert-view>
    </div><!--wrapper-->
  </div>

</template>

<script>
import { getNow } from "@/pages/utils/tool";
import MobileDetect from "mobile-detect";
import { mapActions, mapGetters } from "vuex";
import dateTimeTool from "@/components/dateTimeTool";
import DrawCanvas from "@/components/DrawCanvas";
import UploadView from "@/components/UploadView";
import ApplicationModel from "../../models/ApplicationModel";
import UseCaseView from "../../components/UseCaseView";
import AlertView from '@/components/AlertView';

const md = new MobileDetect(window.navigator.userAgent);

export default {
  name: "EditCAProductFrom",
  props: {
    loading: Boolean,
    isSaveSuccess: Boolean,
  },
  components: { dateTimeTool, DrawCanvas, UploadView, UseCaseView, AlertView },
  data() {
    return {
      isMobile: md.phone(),
      loadingInfo: this.loading,
      editedIndex: -1,
      editedItem: null,
      defaultItem: new ApplicationModel(),
      signDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      dateInfoDialog: {
        key: "",
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      signKey: "customer",
      productList: [],
      promotion: {},
      promotionRule: {},
    };
  },
  created() {
    this.editedIndex = this.$route.query.editIndex;
    console.log(
      `Edit Credit Product1 ${this.editedIndex} ${this.$route.query.caseId}`
    );

    if (this.editedIndex === 0 || parseInt(this.editedIndex, 10) === 0) {
      // 編輯
      console.log(`this.$route.query.caseId  === ${this.$route.query.caseId }`)
      this.caInfo({ caseId: this.$route.query.caseId }).then(
        (results) => {
          if (results.length === 0) {
            // 重複
            this.showMessageDialog(
              "錯誤",
              "查無資料",
              true,
              () => {},
              () => {}
            );
          } else {
            console.log(`result === ${JSON.stringify(results.data.data)}`)
            this.editedItem = results.data.data;
            if (!this.editedItem.vendor.signature) {
              this.editedItem.vendor.signature = "";
            }
            if (!this.editedItem.customer.birthdayInfo) {
              this.$set(this.editedItem.customer, "birthdayInfo", {
                year: "",
                month: "",
                day: "",
                isRepublic: true,
                startCount: 0,
              });
            }
            if (!this.editedItem.signImage0) {
              this.editedItem.signImage0 = null;
            }
            if (!this.editedItem.signImage1) {
              this.editedItem.signImage1 = null;
            }
            if (!this.editedItem.signImage2) {
              this.editedItem.signImage2 = null;
            }
            if (!this.editedItem.signImage0Url) {
              this.editedItem.signImage0Url = null;
            }
            if (!this.editedItem.signImage1Url) {
              this.editedItem.signImage1Url = null;
            }
            if (!this.editedItem.signImage2Url) {
              this.editedItem.signImage2Url = null;
            }
          }
          this.loadCaseRule();
        }
      );
    } else {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.caseId = Math.uuidFast();
      this.editedItem.displayId = this.$route.query.caseId;
      this.editedItem.category = parseInt(this.$route.query.caseCategory, 10);

      const now = new Date();
      this.defaultItem.applyDate.year = `${now.getFullYear() - 1911}`;
      this.defaultItem.applyDate.month = `${
        now.getMonth() + 1 < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1
      }`;
      this.defaultItem.applyDate.day = `${
        now.getDate() + 1 < 10 ? `0${now.getDate()}` : now.getDate()
      }`;

      this.editedItem.vendor.productName = "";
      this.loadCaseRule();
    }

    if (this.getAgentInfo) {
      if (this.getAgentInfo.enableFinanceAgent) {
        this.editedItem.vendor.salesCellphone = this.getAgentInfo.financePhone;
        this.editedItem.vendor.signature = this.getAgentInfo.financeName;
      }
    }
  },
  computed: {
    ...mapGetters(["getUserInfo", "getAgentList", "getAgentInfo"]),
    canCustomPrice() {
      if (
        this.getAgentInfo.agentId === "KwarcyDi4BOv75RNE5SLBOwvia32" ||
        this.getAgentInfo.agentId === "t76gyOZwV8NouQAD6WoTEH7cSzB2" ||
        this.getAgentInfo.agentId === "MXiKEOWVx8O0OxlBjab5Yro9dOr1" ||
        this.getAgentInfo.canCustomPrice === true ||
        this.isAdmin
      ) {
        return true;
      }
      return false;
    },
    getInstallmentsNumberList() {
      let numberList = []; // [12, 15, 18, 20, 24];
      if (Object.keys(this.promotionRule).length > 0) {
        numberList = this.promotionRule["installments"];
      }
      return numberList;
    },
    isAdmin() {
      return this.getUserInfo.authority === "admin";
    },
    yearList() {
      const start = new Date().getFullYear();
      const end = 1911;
      const list = [];
      for (let i = start; i >= end; i--) {
        list.push({ key: `${i - 1911}`, name: `${i - 1911}` });
      }
      return list;
    },
    monthList() {
      return [
        { name: "01", key: "01" },
        { name: "02", key: "02" },
        { name: "03", key: "03" },
        { name: "04", key: "04" },
        { name: "05", key: "05" },
        { name: "06", key: "06" },
        { name: "07", key: "07" },
        { name: "08", key: "08" },
        { name: "09", key: "09" },
        { name: "10", key: "10" },
        { name: "11", key: "11" },
        { name: "12", key: "12" },
      ];
    },
    dayList() {
      const startIndex = 1;
      const list = [];
      for (let i = startIndex; i <= 31; i++) {
        if (i < 10) {
          list.push({ key: `0${i}`, name: `0${i}` });
        } else {
          list.push({ key: `${i}`, name: `${i}` });
        }
      }
      return list;
    },
    relationshipList() {
      return [
        { key: 1, name: "配偶" },
        { key: 2, name: "父母" },
        { key: 3, name: "兄弟姐妹" },
        { key: 4, name: "其他親友" },
        { key: 5, name: "同事" },
        { key: 6, name: "朋友" },
        { key: 7, name: "子女" },
        { key: 8, name: "其他" },
      ];
    },
    cityList() {
      return [
        { key: "10001", name: "北縣" },
        { key: "10002", name: "宜縣" },
        { key: "10003", name: "桃縣" },
        { key: "10004", name: "竹縣" },
        { key: "10005", name: "苗縣" },
        { key: "10006", name: "中縣" },
        { key: "10007", name: "彰縣" },
        { key: "10008", name: "投縣" },
        { key: "10009", name: "雲縣" },
        { key: "10010", name: "嘉縣" },
        { key: "10011", name: "南縣" },
        { key: "10012", name: "高縣" },
        { key: "10013", name: "屏縣" },
        { key: "10014", name: "東縣" },
        { key: "10015", name: "花縣" },
        { key: "10016", name: "澎縣" },
        { key: "10017", name: "基市" },
        { key: "10018", name: "竹市" },
        { key: "10020", name: "嘉市" },
        { key: "09007", name: "連江" },
        { key: "09020", name: "金門" },
        { key: "63000", name: "北市" },
        { key: "64000", name: "高市" },
        { key: "65000", name: "新北市" },
        { key: "66000", name: "中市" },
        { key: "67000", name: "南市" },
        { key: "68000", name: "桃市" },
      ];
    },
    caseTypeList(){
        return [
          { key:'AA21', text:'機車原車抵押AR' },
          { key:'AA22', text:'機車借新還舊AR' },
          { key:'AA23', text:'機車他行代償AR' },
        ];
      },
  },
  methods: {
    ...mapActions([
      "fetchFinanceCreditList",
      "saveFinanceCreditData",
      "removeFinanceCreditData",
      "fetchAgentList",
      "uploadImageData",
      "caseRuleInfo",
      "caInfo"
    ]),
    customerDateChange(dateValue){
      this.editedItem.customer.birthday = dateValue;
    },
    jointGuarantorDateChange(dateValue){
      this.editedItem.jointGuarantor.birthday = dateValue;
    },
    checkCondition(value) {
      let code = "";
      let index = 0;
      const isChecked = !this.editedItem.header.caType[value].value;
      for (let i = 0; i < 3; i++) {
        this.editedItem.header.caType[i].value = false;
      }
      this.editedItem.header.caType[value].value = isChecked;
      if (isChecked) {
        if (value === 0) {
          code = "DM41";
        } else if (value === 1) {
          code = "DM42";
        } else if (value === 2) {
          code = "DM16";
          index = 1;
        }
      }
      this.businessTypeProjects(code,index)
    },
    businessTypeProjects(code, index ){
      this.promotion = {};
      this.promotionRule = {};
      // this.editedItem.vendor.productName = "";

      if (code) {
        const tempPromotion = this.productList[index]["promotion_no"].filter(
          (item) => item.code === code
        );
        this.promotion = tempPromotion[0];
        // this.editedItem.vendor.productName =
        //   this.productList[index]["explanation"] +
        //   "-" +
        //   this.promotion["explanation"];
        const tempPromotionRule = this.productList[index]["rule"].filter(
          (item) => item.code === code
        );
        this.promotionRule = tempPromotionRule[0];
      }

      this.editedItem.vendor.totalPrice = code
        ? this.promotionRule["cost_max"]
        : 0;
      this.editedItem.useCase.cardless_code = code
        ? this.productList[index]["product_code"]
        : "";
      this.editedItem.useCase.supplier_business_type = code ? "CA20" : "";
      this.editedItem.useCase.supplier_business_type_projects = code
        ? code
        : "";
      this.changeInstallmentsNumber();
    },
    changeInstallmentsNumber() {
      this.editedItem.vendor.creditPriceMonth = Math.ceil(
        this.editedItem.vendor.totalPrice /
          this.editedItem.vendor.installmentsNumber
      );
      this.editedItem.vendor.totalCreditPrice =
        parseInt(this.editedItem.vendor.installmentsNumber) *
        parseInt(this.editedItem.vendor.creditPriceMonth);
    },
    signImageSrc(itemPath) {
      let source = null;
      if (itemPath === "signImage1") {
        if (this.editedItem.signImage1) {
          source = this.editedItem.signImage1;
        } else if (this.editedItem.signimage1Url) {
          source = this.editedItem.signimage1Url;
        }
      } else if (itemPath === "signImage2") {
        if (this.editedItem.signImage2) {
          source = this.editedItem.signImage2;
        } else if (this.editedItem.signimage2Url) {
          source = this.editedItem.signimage2Url;
        }
      } else if (itemPath === "signImage3") {
        if (this.editedItem.signImage3) {
          source = this.editedItem.signImage3;
        } else if (this.editedItem.signimage3Url) {
          source = this.editedItem.signimage3Url;
        }
      }
      return source;
    },
    checkHomeType() {
      if (this.editedItem.customer.home.homeType1[0].value) {
        this.editedItem.customer.home.homeAddress1 = this.editedItem.customer.home.residenceAddress;
      } else {
        this.editedItem.customer.home.homeAddress1 = "";
      }
    },
    checkCreditcardStatus(value) {
      const isChecked = this.editedItem.bank.type[value].value
      console.log(`isChecked === ${isChecked} value === ${value}`)
      const callback = (item,index) => {
        item.value = false
      }
      this.editedItem.bank.type.forEach(callback);
      this.editedItem.bank.type[value].value = isChecked
      if(isChecked) {
        const status = value + 1
        this.editedItem.useCase.creditcard_status = status
        if(value === 3) {
          this.editedItem.useCase.creditcard_status_remark = this.editedItem.bank.otherType;
        }
      }
    },
    setOtherType() {
      if(this.editedItem.bank.otherType) {
        const callback = (item,index) => {
          item.value = index === 3
        }
        this.editedItem.bank.type.forEach(callback);
        this.editedItem.useCase.creditcard_status_remark = this.editedItem.bank.otherType;
      }
      this.editedItem.useCase.creditcard_status_remark = this.editedItem.bank.otherType;
    },
    showDateToolDialog(key) {
      this.dateInfoDialog.key = key;
      this.dateInfoDialog.visible = true;
      this.dateInfoDialog.text = "請選擇日期";
      this.dateInfoDialog.confirm = () => {
        // console.log(JSON.stringify(this.editedItem.customer.birthdayInfo));
        if (key === "birthday") {
          this.editedItem.customer.birthday = `${this.editedItem.customer.birthdayInfo.year}年${this.editedItem.customer.birthdayInfo.month}月${this.editedItem.customer.birthdayInfo.day}日`;
        }
        if (key === "memberIdDate") {
          this.editedItem.customer.memberIdDate = `${this.editedItem.customer.memberIdDateInfo.year}年${this.editedItem.customer.memberIdDateInfo.month}月${this.editedItem.customer.memberIdDateInfo.day}日`;
        }
        if (key === "jointGuarantor.birthday") {
          this.editedItem.jointGuarantor.birthday = `${this.editedItem.jointGuarantor.birthdayInfo.year}年${this.editedItem.jointGuarantor.birthdayInfo.month}月${this.editedItem.jointGuarantor.birthdayInfo.day}日`;
        }
        if (key === "jointGuarantor.memberIdDate") {
          this.editedItem.jointGuarantor.memberIdDate = `${this.editedItem.jointGuarantor.memberIdDateInfo.year}年${this.editedItem.jointGuarantor.memberIdDateInfo.month}月${this.editedItem.jointGuarantor.memberIdDateInfo.day}日`;
        }
        this.dateInfoDialog.visible = false;
      };
    },
    showTip() {
      if (this.firstTipCount < 1) {
        this.firstTipCount += 1;
        this.showMessageDialog(
          "提示",
          "聯絡人一率保密，僅在逾期繳款才會通知聯絡人",
          true,
          () => {},
          () => {}
        );
        setTimeout(() => {
          this.messageDialog.visible = false;
        }, 2500);
      }
    },
    showSecondTip() {
      if (this.secondTipCount < 1) {
        this.secondTipCount += 1;
        this.showMessageDialog(
          "提示",
          "聯絡人一率保密，僅在逾期繳款才會通知聯絡人",
          true,
          () => {},
          () => {}
        );
        setTimeout(() => {
          this.messageDialog.visible = false;
        }, 2500);
      }
    },
    showSignDialog(key) {
      this.signKey = key;
      this.signDialog.visible = true;
    },
    setTypeEvent(type) {
      if (type === 1) {
        const relationshipArray = this.relationshipList.filter(
          (item) => item.key === this.editedItem.firstContact.relationship
        );
        this.editedItem.firstContact.type =
          relationshipArray.length > 0 ? relationshipArray[0].name : "";
      } else if (type === 2) {
        const relationshipArray = this.relationshipList.filter(
          (item) => item.key === this.editedItem.secondContact.relationship
        );
        this.editedItem.secondContact.type =
          relationshipArray.length > 0 ? relationshipArray[0].name : "";
      } else if (type === 2) {
        const relationshipArray = this.relationshipList.filter(
          (item) => item.key === this.editedItem.jointGuarantor.relationship
        );
        this.editedItem.jointGuarantor.type =
          relationshipArray.length > 0 ? relationshipArray[0].name : "";
      }
    },
    setMemberIdCity(type) {
      if (type === 1) {
        const cityArray = this.cityList.filter(
          (item) => item.key === this.editedItem.useCase.issue_place
        );
        this.editedItem.customer.memberIdCity =
          cityArray.length > 0 ? cityArray[0].name : "";
      } else if (type === 2) {
        const cityArray = this.cityList.filter(
          (item) => item.key === this.editedItem.useCase.issue_place
        );
        this.editedItem.jointGuarantor.memberIdCity =
          cityArray.length > 0 ? cityArray[0].name : "";
      }
    },
    async handleDownloadSign(image) {
      console.log(`handleDownloadSign == ${image}`);
      if (this.signKey === "jointGuarantor") {
        this.editedItem.signImage3 = image;
      } else {
        this.editedItem.signImage0 = image;
        this.editedItem.signImage1 = image;
        this.editedItem.signImage2 = image;
      }

      this.signDialog.visible = false;
      this.signDialog.confirm = () => {
        if (this.signKey === "jointGuarantor") {
          this.editedItem.signImage3 = image;
        } else {
          this.editedItem.signImage0 = image;
          this.editedItem.signImage1 = image;
          this.editedItem.signImage2 = image;
        }
        this.signDialog.visible = false;
      };
    },
    handleDownloadClose() {
      this.signDialog.visible = false
    },
    checkFormData() {
      // if (!this.editedItem.signImage0) {
      //   this.showMessageDialog('錯誤', '請填寫姓名！', true, () => {
      //   }, () => {
      //   });
      //   return false;
      // }

      if (this.editedItem.customer.cellphone === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫行動電話！",
          true,
          () => {},
          () => {}
        );
        return false;
      } else if (this.editedItem.customer.cellphone) {
        let errorMessage = ""
        if (this.editedItem.customer.cellphone.length != 10) {
          errorMessage = "行動電話號碼應為10碼！"
        } else if (! /^09\d{8}$/.test(this.editedItem.customer.cellphone)) {
          errorMessage = "行動電話號碼應為09開頭！"
        }

        if(errorMessage) {
          this.showMessageDialog(
            "錯誤",
            errorMessage,
            true,
            () => {},
            () => {}
          );
          return false;
        }
      }

      if (
        Object.keys(this.promotion).length === 0 ||
        Object.keys(this.promotionRule).length === 0
      ) {
        this.showMessageDialog(
          "錯誤",
          "請選擇貸款條件！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      if (this.editedItem.customer.memberId === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫身分證！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      if (this.editedItem.customer.birthday === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫生日！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      let birthday = new Date(
        parseInt(this.editedItem.customer.birthdayInfo.year) + 1911,
        this.editedItem.customer.birthdayInfo.month,
        this.editedItem.customer.birthdayInfo.day
      );

      var d = new Date();
      var age =
        d.getFullYear() -
        birthday.getFullYear() -
        (d.getMonth() < birthday.getMonth() ||
        (d.getMonth() == birthday.getMonth() &&
          d.getDate() < birthday.getDate())
          ? 1
          : 0);

      const ageMin = this.promotionRule["age_min"];
      const ageMax = this.promotionRule["age_max"];

      if (age < ageMin || age > ageMax) {
        this.showMessageDialog(
          "錯誤",
          `申請年齡只能 ${ageMin} 到 ${ageMax} 歲區間！`,
          true,
          () => {},
          () => {}
        );
        return false;
      }

      if (this.editedItem.vendor.totalPrice > this.promotionRule["cost_max"]) {
        this.showMessageDialog(
          "錯誤",
          `商品總價不得大於 ${this.promotionRule["cost_max"]} 元！`,
          true,
          () => {},
          () => {}
        );
        return false;
      }

      if (this.editedItem.useCase.issue_place === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫發證地點！",
          true,
          () => {},
          () => {}
        );
        return false;
      }

      if (this.editedItem.useCase.employment_status === 1) {
        let errorMessage = ""
        if (this.editedItem.company.name) {
          errorMessage = "請填寫貸款者服務單位名稱"
        } else if (this.editedItem.company.phone) {
          errorMessage = "請填寫貸款者服務單位電話"
        }
        if (errorMessage) {
          this.showMessageDialog(
            "錯誤",
            errorMessage,
            true,
            () => {},
            () => {}
          );
          return false;
        }
      }


      if (this.editedItem.customer.residenceAddress === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫戶籍地址！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      if (this.editedItem.company.name === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫公司名稱！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      if (this.editedItem.company.phone === "") {
        this.showMessageDialog(
          "錯誤",
          "請填寫公司電話！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      console.log( `${this.editedItem.bank.type[0].value }  ==
        ${this.editedItem.bank.type[1].value} ===
        ${this.editedItem.bank.type[2].value} &&
        ${this.editedItem.bank.type[3].value}`)
      if (
        !this.editedItem.bank.type[0].value &&
        !this.editedItem.bank.type[1].value &&
        !this.editedItem.bank.type[2].value &&
        !this.editedItem.bank.type[3].value
      ) {
        this.showMessageDialog(
          "錯誤",
          "請選擇信用卡狀態！",
          true,
          () => {},
          () => {}
        );
        return false;
      } else if (
        this.editedItem.bank.type[3].value &&
        !this.editedItem.bank.otherType
      ) {
        this.showMessageDialog(
          "錯誤",
          "請填寫信用卡其他狀態！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      if (
        !this.editedItem.hasJointGuarantor[0].value &&
        !this.editedItem.hasJointGuarantor[1].value &&
        !this.editedItem.hasJointGuarantor[2].value &&
        !this.editedItem.hasJointGuarantor[3].value
      ) {
        this.showMessageDialog(
          "錯誤",
          "請選擇保證人身分！",
          true,
          () => {},
          () => {}
        );
        return false;
      } else {
        if (this.editedItem.hasJointGuarantor[0].value) {
          this.editedItem.useCase.guarantor_option = 1;
        } else if (this.editedItem.hasJointGuarantor[1].value) {
          this.editedItem.useCase.guarantor_option = 2;
        } else if (this.editedItem.hasJointGuarantor[2].value) {
          this.editedItem.useCase.guarantor_option = 3;
        } else if (this.editedItem.hasJointGuarantor[3].value) {
          this.editedItem.useCase.guarantor_option = 4;
        }
      }

      if (
        this.editedItem.firstContact.name === "" ||
        this.editedItem.firstContact.cellphone === "" ||
        this.editedItem.firstContact.relationship === 0
      ) {
        this.showMessageDialog(
          "錯誤",
          "請填寫第一聯絡人姓名、關係、電話！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      // if (this.editedItem.secondContact.name === '' || this.editedItem.secondContact.cellphone === ''
      //     || this.editedItem.secondContact.type === '') {
      //   this.showMessageDialog('錯誤', '請填寫第二聯絡人姓名、關係、電話！', true, () => {
      //   }, () => {
      //   });
      //   return false;
      // }
      if (this.editedItem.jointGuarantor.name !== "") {
        let hasCheck = false;
        this.editedItem.hasJointGuarantor.forEach((item) => {
          if (item.value === true) {
            hasCheck = true;
          }
        });
        if (!hasCheck) {
          this.showMessageDialog(
            "錯誤",
            "請勾選保證人的選項！",
            true,
            () => {},
            () => {}
          );
          return false;
        }
      }

      if (!this.editedItem.customer.home.residencePost) {
        this.showMessageDialog(
          "錯誤",
          "請填戶籍地的郵遞區號！",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      if (!this.editedItem.customer.home.homePost) {
        this.showMessageDialog(
          "錯誤",
          "請填住宅地的郵遞區號",
          true,
          () => {},
          () => {}
        );
        return false;
      }
      if (!this.editedItem.bankId || !this.editedItem.bankSubId) {
        this.showMessageDialog(
          "錯誤",
          "請填撥款銀行帳戶！",
          true,
          () => {},
          () => {}
        );
        return false;
      }

      if (!this.editedItem.files.length) {
        this.showMessageDialog(
          "錯誤",
          "請上傳貸款文件相關圖檔！",
          true,
          () => {},
          () => {}
        );
        return false;
      } else if (this.editedItem.files.length > 0) {
        let message = "";
        const codeArray = ["LDR1", "LDR2", "LDR3"];
        codeArray.forEach((name) => {
          const index = this.editedItem.files
            .map(function (e) {
              return e.key;
            })
            .indexOf(name);
          if (index > -1) {
            if (name === "LDR1") {
              message = "申請人身分證正面";
            } else if (name === "LDR2") {
              message = "申請人身分證反面";
            } else if (name === "LDR2") {
              message = "申請人身撥款帳戶存摺封面";
            }
          }
        });

        if (message.length > 0) {
          message = "請上傳" + message + "文件 ！";
          this.showMessageDialog(
            "錯誤",
            message,
            true,
            () => {},
            () => {}
          );
          return false;
        }
      }
      this.updateData()
      return true;
    },
    updateData() {
      if(!this.editedItem.company.workYear) {
        this.editedItem.company.workYear = 0
      }
      if(!this.editedItem.company.workMonth) {
        this.editedItem.company.workMonth = 0
      }
      if(!this.editedItem.company.salary) {
        this.editedItem.company.salary = 0
      }
    },
    save() {
      if (this.checkFormData()) {
        this.$emit("saveData", this.editedItem);
      }
    },
    changeEvent(item) {
      console.log(`changeEvent item === ${JSON.stringify(item)}`);
      this.editedItem.laonhfcInfo = item.itemInfo;
      this.editedItem.bankId = item.bankId;
      this.editedItem.bankSubId = item.bankSubId;
      this.editedItem.bankAccount = item.bankAccount;
      this.editedItem.useCase.employment_status = item.employment_status;
    },
    uploadEvent(items) {
      this.editedItem.files = items;
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    async loadCaseRule() {
      this.loadingInfo = true;

      try {
        const res = await this.caseRuleInfo();
        const result = res.data.data;
        this.loadingInfo = false;
        if (result) {
          console.log(`loadCaseRule === ${JSON.stringify(result)}`);
          const product_item = result.rows_data[0];
          const company = product_item["company"];
          console.log(`company === ${company}`)
          if(this.editedItem) {
            this.editedItem.useCase.company = company;
          }

          this.productList = product_item["product_item"];
          this.productList = this.productList.filter(
            (item) => item.bus_type === "CA20"
          );
          if(this.editedItem.useCase.supplier_business_type_projects) {
            const code = this.editedItem.useCase.supplier_business_type_projects;
            let typeIndex = 0;
            let index = 0;
            if(code == "DM42") {
              typeIndex = 1;
            } else if (code == "DM16"){
              typeIndex = 2;
              index = 1;
            }

            this.editedItem.header.caType[typeIndex].value = true;
            this.businessTypeProjects(code,index)
          }
        }
      } catch (e) {
        this.loadingInfo = false;
        let title = "錯誤";
        let message = `發生錯誤 ${e}`;
        this.showMessageDialog(
          title,
          message,
          true,
          () => {},
          () => {}
        );
      }
    },
  },
};
</script>

<style scoped src="../../assets/css/ca_product_view.css">
</style>

<style scoped>
table.blueTable1 td,
table.blueTable2 td,
table.blueTable3 td,
table.blueTable4 td,
table.blueTable5 td,
table.blueTable6 td,
table.blueTable7 td,
table.blueTable8 td,
table.blueTable9 td,
table.blueTable10 td {
  padding: 0 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/web/EditCAProductFrom.vue